import { render } from "./thank_you_page.html?vue&type=template&id=1d821063&external"
import script from "./thank_you_page.js?vue&type=script&lang=js&external"
export * from "./thank_you_page.js?vue&type=script&lang=js&external"

import "@/assets/css/index.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__